import React from "react";

// Matches http(s):// links and bare www. links in user-generated text.
const URL_RE = /(https?:\/\/[^\s<]+|www\.[^\s<]+)/gi;

// URLs pasted in prose often end with punctuation that isn't part of the link.
const cleanTrailing = (url) => {
  const m = url.match(/[),.!?;:'"\]]+$/);
  return m ? url.slice(0, url.length - m[0].length) : url;
};

// Renders plain text with any URLs turned into safe, clickable links.
// Keep whitespace-pre-line (or similar) on the parent element to preserve line breaks.
export function LinkedText({ text, className = "", linkTestId = "post-link" }) {
  if (text == null || text === "") return null;
  const str = String(text);
  const parts = [];
  let last = 0;
  let m;
  URL_RE.lastIndex = 0;
  while ((m = URL_RE.exec(str)) !== null) {
    const match = m[0];
    const start = m.index;
    if (start > last) parts.push(str.slice(last, start));
    const trimmed = cleanTrailing(match);
    const trailing = match.slice(trimmed.length);
    const href = trimmed.startsWith("http") ? trimmed : `https://${trimmed}`;
    parts.push(
      <a
        key={start}
        href={href}
        target="_blank"
        rel="noopener noreferrer nofollow ugc"
        onClick={(e) => e.stopPropagation()}
        data-testid={linkTestId}
        className="text-gold underline decoration-gold/40 underline-offset-2 hover:decoration-gold break-all"
      >
        {trimmed}
      </a>
    );
    if (trailing) parts.push(trailing);
    last = start + match.length;
  }
  if (last < str.length) parts.push(str.slice(last));
  return <span className={className}>{parts}</span>;
}
